import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { CalendarDays, Loader2 } from "lucide-react";
import { http, errMsg } from "../../lib/api";

export const FillDays = () => {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => http.get("/kits-bulk/fill-days").then((x) => setD(x.data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);
  const active = d && (d.pending > 0 || d.running);
  useEffect(() => {
    if (!active) return undefined;
    const t = setInterval(load, 10000);
    return () => clearInterval(t);
  }, [active, load]);
  if (!d || (!d.kits_to_fill && !active)) return null;
  const go = async () => {
    setBusy(true);
    try {
      const { data } = await http.post("/kits-bulk/fill-days", {});
      toast.message(`Filling day pages in ${data.queued.length} Founder's kit(s), one at a time — you can leave this page`);
      await load();
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <section data-testid="fill-days-panel" className="mb-6 flex flex-wrap items-center gap-3 rounded-lg border border-stone-200 bg-white p-4">
      <CalendarDays size={18} className="text-[#9A7B2C]" />
      <b className="text-[#2B2A26]">Founder's day pages</b>
      <span data-testid="fill-days-status" className="text-sm text-stone-500">
        {active ? `Filling${d.running ? ` ${d.running}` : ""}${d.pending ? ` · ${d.pending} kit(s) waiting` : ""}` : `${d.kits_to_fill} kit(s) have day pages that aren't full`}
      </span>
      {active ? <Loader2 size={15} className="ml-auto animate-spin text-[#9A7B2C]" /> : (
        <button data-testid="fill-days-btn" disabled={busy} onClick={go}
          className="ml-auto inline-flex items-center gap-1.5 rounded-sm bg-[#2B2A26] px-3 py-1.5 text-xs font-bold text-white hover:bg-black transition-colors disabled:opacity-50">
          {busy && <Loader2 size={12} className="animate-spin" />} Fill day pages
        </button>
      )}
    </section>
  );
};
